(function ($, Drupal, window, document) {

  'use strict';

  Drupal.behaviors.dms = {
    attach: function (context, settings) {

      // Initialize tippy
      tippy('[data-tippy-content]');

      $(once('subtoggle', '.menu--main .menu__item--expanded')).each(function() {
      $(this).prepend('<div class="subtoggle"></div>');
    });

    // $('.subtoggle').on('click', function() {
    //   $('.menu--main .menu__list .menu__list').hide();
    //   // $(this).parents('.menu__item').toggleClass('open').siblings('.menu__list').slideDown();
    //   // $(this).parents('.menu__item').toggleClass('open');
    //   $(this).siblings('.menu__list').slideDown();
    // });
    // $(once('slidedown', '.menu__item--expanded.menu__item--active .subtoggle')).each(function() {
    //   $(this).siblings('.menu__list').slideDown();
    // });

    // YERA
    // You can do on hover with the code underneath, but there still needs to be some finetuning.
    // For instance -> Checking in JS for mobile/touch devices
    // Theming changes so that the hover stays active when you go from 'expanded -> to menu__item'



    if($(window).width() > 768) {
      $('.menu--main .menu__item--expanded').on('mouseenter', function() {
        $(this).find('> .menu__list').show();
      });

      $('.menu--main .menu__item--expanded').on('mouseleave', function() {
        $(this).find('> .menu__list').hide();
      });
    }

    else {
      $('.subtoggle').on('click', function() {
        $('.menu--main .menu__list .menu__list').hide();
        // $(this).parents('.menu__item').toggleClass('open').siblings('.menu__list').slideDown();
        // $(this).parents('.menu__item').toggleClass('open');
        $(this).siblings('.menu__list').slideDown();
      });
      $(once('subtoggle', '.menu__item--expanded.menu__item--active .subtoggle')).each(function() {
        $(this).siblings('.menu__list').slideDown();
      });
    }

      // First pg
      $(once('addClass', '#sections-container .paragraph:first-child, .node__content .paragraph:first-child')).addClass('first-pg');

      // Off Canvas menu image
      $('.off-canvas-menu-wrapper .menu__item').hover(function() {
        if ($(this).is('[data-menu-image')) {
          var menuImage = $(this).attr('data-menu-image');
        }

        else {
          var menuImage = '/themes/custom/fujirebio/img/default-menu-image.jpg';
        }
        $('.off-canvas-image-wrapper').css('background-image','url("' + menuImage + '")');
      });

      if ($('.off-canvas-menu-wrapper .menu__item > a.is-active').length) {
        var item = $('.off-canvas-menu-wrapper .menu__item > a.is-active');
        if($(item).parent().attr('data-menu-image')) {
          $('.off-canvas-image-wrapper').css('background-image','url("' + $(item).parent().attr('data-menu-image') + '")');
        }
      }

      // Product pg menu
      if ($('.paragraphs_menu--tabs').length) {
        var items = $('.paragraphs_menu--tabs li').length;
        if (items > 5) {
          $('.paragraphs_menu--tabs').addClass('big');
        }
      }

      // Unveil
      $('.unveil').unveil();

      $('.scrollTo').click(function(e){
      	var jump = $(this).attr('href');

        if(jump.includes('#')) {
          var new_position = $(jump).offset();
          var top = new_position.top - 80;
        	$('html, body').stop().animate({ scrollTop: top }, 750);
          e.preventDefault();
        }
      });

      // AOS
      AOS.init({
        delay: 200,
        once: true,
        // startEvent: 'load',
      });
      $(document).ajaxComplete(function() {
        AOS.init({
          delay: 200,
          // once: true,
          // startEvent: 'load',
        });
      });
      window.addEventListener('load', AOS.refresh);

      //sticky menu
      var sticky;
      sticky = new Sticky('.thematic__anchor_links');

      document.addEventListener('scroll', function(e) {
        if(document.querySelector('.thematic__anchor_links.is-sticky')) {
          $('.anchor_placeholder').addClass('active');
          var anchor_outer_height = $('.thematic__anchor_links').outerHeight();
          $('.anchor_placeholder').css('height', anchor_outer_height + 20);
          //$('.anchor_placeholder.active').matchHeight({target:$('.thematic__anchor_links')});
          var height_headroom = 0;
          if ($('.headroom--pinned').length) {
            var height_headroom = $('.headroom--pinned').outerHeight();
          }
          $('.anchor_placeholder').css('top', height_headroom);
          $('.thematic__anchor_links').css('margin-top', height_headroom);
        }
        else if(document.querySelector('.thematic__anchor_links')) {
          $('.anchor_placeholder').removeClass('active');
        }
      });


      //1) create a function
      var handleMatchMedia = function(md) {
          if (md.matches) {
            $('.thematic__anchor_links').prepend('<li class="thematic__anchor_links__toggle"><i class="fa fa-bars"></i> ' + Drupal.t('Jump to content') + '</li>');
            var $anchorFilterToggle = $('.thematic__anchor_links__toggle');
            $('.thematic__anchor_links li').not('.thematic__anchor_links__toggle').hide();
            $anchorFilterToggle.click(function() {
              $('.thematic__anchor_links li').not('.thematic__anchor_links__toggle').toggle();
               var anchor_outer_height = $('.thematic__anchor_links').outerHeight();
               $('.anchor_placeholder').css('height', anchor_outer_height + 20);
            });
            $('.node-type-thematic_hub_overview_page .thematic__anchor_links .anchor_link').click(function(e) {
              $('.thematic__anchor_links li').not('.thematic__anchor_links__toggle').hide();
            });
          } else {
            $('.thematic__anchor_links li').not('.thematic__anchor_links__toggle').show();
            $('.thematic__anchor_links__toggle').remove();
          }
      }
      var mq = window.matchMedia("(max-width: 768px)");
      // 2) call the function
      handleMatchMedia(mq);
      //3) call the addListener function
      mq.addListener(handleMatchMedia);

      //le scroll effect, oui oui non non. Ce n'dest pas toujours facile.
      $('.node-type-thematic_hub_overview_page .thematic__anchor_links .anchor_link').click(function(e) {
        var jump = $(this).attr('href');

        if(jump.includes('#')) {
          var new_position = $(jump).offset();
          var top = new_position.top - 80;
        	$('html, body').stop().animate({ scrollTop: top }, 750);
          e.preventDefault();
        }
      });

      if($('.node-type-thematic_hub_overview_page').length != 0 && $('.node-type-thematic_hub_overview_page .view-events').length == 0) {
        $('.events-overview').hide();
        $('.thematic_anchor_link__event').hide();
      }

      if (typeof context['location'] !== 'undefined') {

        // Do stuff...

        // Be carefull when editing stuff below!

        // Mobile menu
        $('.js-mm-toggle').click(function(e) {
          $('html, body').animate({ scrollTop: 0 });
          $('body').toggleClass('mm-open');
          e.preventDefault();
        });

        // Tracking
        $('a[href^="mailto:"]').addClass('gtm-mail');
        $('a[href^="tel:"]').addClass('gtm-phone');
      }
    }
  };

  Drupal.behaviors.headerVideo = {
    attach: function (context, settings) {
      var vid = document.getElementById("header__video");
      if(vid !== null) {
        vid.autoplay = true;
        vid.load();
      }
    }
  };

  Drupal.behaviors.documentCenterAnonymous = {
    attach: function (context, settings) {
      $('.anon-document-button', context).on('click', function() {
        $('.document-search-block-popup-anonymous').fadeIn();
        $('body').toggleClass('active-popup');
      });
    }
  };

  // Drupal.behaviors.documentCenterCloseIconClick = {
  //   attach: function (context, settings) {
  //     var modal = document.getElementById('document-search-anonymous');

  //     $('.documentsearchpopupclose', context).on('click', function() {
  //       modal.style.display = "none";
  //       $('body').removeClass('active-popup');
  //     });

  //   }
  // };

  Drupal.behaviors.documentCenterOtherDocumentsAnonymous = {
    attach: function (context, settings) {
      $('.other-documents-anon', context).on('click', function(e) {
        e.preventDefault();
        $('.other-documents-popup-anonymous').fadeIn();
        $('body').toggleClass('active-popup');
      });
    }
  };

  Drupal.behaviors.documentCenterOtherDocumentsCloseIconClick = {
    attach: function (context, settings) {
      var modal = document.getElementById('other-document-anonymous');

      $('.documentsearchpopupclose', context).on('click', function() {
        modal.style.display = "none";
        $('body').removeClass('active-popup');
      });

    }
  };

})(jQuery, Drupal, this, this.document);
